import SkinLogo from "./skin-logo";

export default function PopupHeader({
  skin,
  trackName,
  slowControl,
  isPlaying,
  announcement,
  isPro,
  trialMode,
  trialEnded,
  remainingTrialDays,
  usageHit,
  usageRemaining,
  subscriptionStatusStep,
  notSupported,
  musicProOnly,
  isSlowedEnabled,
  contentApplying,
  mount,
  billingLoading,
  upgradeError,
  onUpgradeClick,
  onManageSubscriptionClick,
  onDebugToggle,
  onSlowedToggle,
  hideManagePlan,
  onUsageClick,
}) {
  const hasTrial = trialMode && remainingTrialDays >= 0;
  const showUnlockButton = !isPro;
  const usageMinutesLeft = Math.max(
    0,
    Math.floor(Number(usageHit ? 0 : usageRemaining) || 0),
  );
  const usageText =
    usageMinutesLeft >= 60
      ? `${Math.floor(usageMinutesLeft / 60)}h ${usageMinutesLeft % 60}m left`
      : `${usageMinutesLeft} min left`;
  // Post-trial weekly allowance: Unlock PRO → Usage mode → minutes left →
  // Resets weekly, including after the cap so 0 min left still cycles.
  const hasUsage = !isPro && !hasTrial && trialEnded === true;
  const showUsageDepletedUnlock = hasUsage && usageHit === true;
  const rotating = hasTrial || hasUsage;
  const maxStep = hasUsage ? 3 : 2;
  const step = rotating ? Math.min(subscriptionStatusStep || 0, maxStep) : 0;
  const daysText =
    remainingTrialDays > 0
      ? `${remainingTrialDays} ${remainingTrialDays === 1 ? "day" : "days"} left`
      : "Last day";
  const statusText = hasTrial ? "Trial mode" : "Usage mode";
  const countdownText = hasTrial ? daysText : usageText;

  return (
    <div className="header">
      <div className="header__content">
        <div className="header__left_button">
          {showUnlockButton && (
            <button
              type="button"
              className={`subscription-status-button subscription-status-button--unlock ${showUsageDepletedUnlock ? "subscription-status-button--unlock-depleted" : ""} subscription-status-button--step-${step}`}
              onClick={hasUsage ? onUsageClick : onUpgradeClick}
            >
              <span className="subscription-status-button__label subscription-status-button__label--default">
                Unlock PRO
              </span>
              {rotating && (
                <span className="subscription-status-button__label subscription-status-button__label--trial-mode">
                  {statusText}
                </span>
              )}
              {rotating && (
                <span className="subscription-status-button__label subscription-status-button__label--trial-days">
                  {countdownText}
                </span>
              )}
              {hasUsage && (
                <span className="subscription-status-button__label subscription-status-button__label--usage-reset">
                  Resets weekly
                </span>
              )}
            </button>
          )}
          {upgradeError && (
            <button
              type="button"
              className="header__upgrade-error"
              onClick={onUpgradeClick}
              title="Try opening checkout again"
            >
              {upgradeError}
            </button>
          )}
          {isPro && !hideManagePlan && (
            <button
              type="button"
              className={`subscription-status-button${billingLoading ? " subscription-status-button--loading" : ""}`}
              disabled={billingLoading}
              aria-busy={billingLoading}
              onClick={onManageSubscriptionClick}
            >
              {billingLoading ? (
                <span className="subscription-status-button__loading">
                  <span className="header__spinner" aria-hidden="true" />
                  Loading
                </span>
              ) : (
                <span className="subscription-status-button__label subscription-status-button__label--default">
                  Manage plan
                </span>
              )}
            </button>
          )}
        </div>

        <div
          className="header__title"
          onDoubleClick={(e) => e.metaKey && onDebugToggle()}
        >
          <SkinLogo
            skin={skin}
            isPro={isPro}
            trialMode={trialMode}
            trackName={trackName}
            slowControl={slowControl}
            playing={
              isPlaying && isSlowedEnabled && !notSupported && !musicProOnly
            }
            announcement={announcement}
          />
        </div>

        <div className="header__right_button">
          {contentApplying ? (
            <span className="header__applying" aria-live="polite">
              <span className="header__spinner" aria-hidden="true" />
              Applying
            </span>
          ) : notSupported ? (
            <span className="header__status header__status--muted">
              Unsupported
            </span>
          ) : musicProOnly ? (
            <span className="header__status header__status--muted">
              Pro only
            </span>
          ) : !isSlowedEnabled && mount ? (
            <span className="header__status">Off</span>
          ) : null}
          <input
            type="checkbox"
            className="switcher"
            checked={isSlowedEnabled}
            disabled={
              notSupported ||
              musicProOnly ||
              contentApplying ||
              (usageHit && !isPro && !hasTrial)
            }
            onChange={() => onSlowedToggle(!isSlowedEnabled)}
          />
        </div>
      </div>

      <div className="header__bar" />
    </div>
  );
}
